import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const SITE_SETTINGS_SERVICE_TOKEN = new InjectionToken('SITE SETTINGS SERVICE TOKEN');
class SiteSettingsService {
    constructor() {
        this.currency$ = new BehaviorSubject('DKK');
        this.locale$ = new BehaviorSubject('en');
        this.siteName$ = new BehaviorSubject('');
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { SITE_SETTINGS_SERVICE_TOKEN, SiteSettingsService };
